export const BUNDLE_NAME = '🍍 NVS Pinia Collection';
export * from './plugins/_bundle';
export * from './globals/api';
export * from './globals/auth';
// Stores
export * from './stores/api/module';
export * from './stores/auth/module';
export * from './stores/context';
//# sourceMappingURL=index.js.map